import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';

const WikimediaSearchBar = ({ onSearch, isSearching, initialQuery = '' }) => {
  const [query, setQuery] = useState(initialQuery);

  // Update local state when initialQuery changes
  useEffect(() => {
    setQuery(initialQuery);
  }, [initialQuery]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim() && !isSearching) {
      onSearch(query);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <input
        type="text"
        className="flex-1 p-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Search Wikimedia Commons (e.g., Eiffel Tower, Times Square)..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        disabled={isSearching}
      />
      <button
        type="submit"
        disabled={isSearching || !query.trim()}
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-2 transition-colors"
      >
        <Search className="w-4 h-4" />
        {isSearching ? 'Searching...' : 'Search'}
      </button>
    </form>
  );
};

export default WikimediaSearchBar;
